import { Link } from "react-router-dom";
import { categories, type Category } from "@/mocks/categories";

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
            探索分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            从不同角度深入了解这部电影，找到你最感兴趣的话题
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat: Category) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-300 hover:shadow-md transition-all duration-300 cursor-pointer no-underline"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-950 whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500 text-center leading-relaxed hidden sm:block">
                {cat.description.length > 24 ? cat.description.slice(0, 24) + "..." : cat.description}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}